import { render, staticRenderFns } from "./UploadForm.vue?vue&type=template&id=52c333ae&"
import script from "./UploadForm.vue?vue&type=script&lang=ts&"
export * from "./UploadForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports